
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { ValidationProvider } from "vee-validate";
import FormGroup from "@/components/form/FormGroupNew.vue";
import FormInputGroup from "@/components/form/FormInputGroupNew.vue";
import FormDatepicker from "@/components/form/FormDatepickerNew.vue";
import FormSelect from "@/components/form/FormSelectNew.vue";
import FormTextarea from "@/components/form/FormTextarea.vue";
import _ from "lodash";
import moment from "moment";
import FormMultiselect from "@/components/form/FormMultiSelect.vue";

@Component({
  components: {
    ValidationProvider,
    FormGroup,
    FormInputGroup,
    FormTextarea,
    FormDatepicker,
    FormMultiselect,
    FormSelect,
  },
})
export default class Interventions extends Vue {
  @Prop({ required: true }) readonly formData!: Record<string, any>;
  localFormData: Record<string, any> = {};

  @Watch("formData", { immediate: true, deep: true })
  onFormDataChange(newVal: Record<string, any>) {
    this.localFormData = _.cloneDeep(newVal);
  }

  frequencyOptions = [
    { label: "Daily", value: "Daily" },
    { label: "Weekly", value: "Weekly" },
    { label: "As Needed", value: "As Needed" },
  ];

  assistance_level = [
    { label: "Independent", value: "Independent" },
    { label: "Minimal Assistance", value: "Minimal Assistance" },
    { label: "Moderate Assistance", value: "Moderate Assistance" },
    { label: "Maximum Assistance", value: "Maximum Assistance" },
    {
      label: "Total Assistance (Dependent)",
      value: "Total Assistance (Dependent)",
    },
  ];

  bathing_frequency = [
    { label: "As Needed", value: "As Needed" },
    { label: "Daily", value: "Daily" },
    { label: "Every Other Day", value: "Every Other Day" },
    { label: "Twice a Week", value: "Twice a Week" },
  ];

  bathing_supervision_level = [
    { label: "None Required", value: "None Required" },
    { label: "Verbal Cues / Reminders", value: "Verbal Cues / Reminders" },
    { label: "Standby Supervision", value: "Standby Supervision" },
    { label: "Partial Supervision", value: "Partial Supervision" },
    { label: "Full Supervision", value: "Full Supervision" },
  ];

  toileting_frequency = [
    { label: "As Needed", value: "As Needed" },
    { label: "Every Hour", value: "Every Hour" },
    { label: "Every Two Hours", value: "Every Two Hours" },
    {
      label: "Scheduled (e.g., Morning, Afternoon, Evening)",
      value: "Scheduled (e.g., Morning, Afternoon, Evening)",
    },
    { label: "Before Bedtime", value: "Before Bedtime" },
    { label: "After Meals", value: "After Meals" },
    { label: "Overnight Assistance", value: "Overnight Assistance" },
  ];

  updateField(field: string, value: any, isDate: boolean = false) {
    if (isDate) {
      this.localFormData[field] = moment(value).toISOString();
    } else {
      this.localFormData[field] = value;
    }
    this.$emit("update:formData", this.localFormData);
  }
}
